import React, { useState, useEffect, useContext } from 'react';
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import handleSubmitForCheckbox from "../../../SuperAdmin/Controller/AssignModuleController/AssignModuleController";
import { Link } from "react-router-dom";

function FormListPage() {
    const navigate = useNavigate();
    const [modulesList, setModules] = useState([]);
    const { t, i18n } = useTranslation();
    const { theme, toggleTheme } = useContext(ThemeContext);
    const isReadOnly = true;
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [checkboxState, setCheckboxState] = useState({});

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };

    const getIDFromQueryString = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('ClientID');
    };

    const ClientID = getIDFromQueryString();

    const handleSubmitForm = async () => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        try {
            await handleSubmitForCheckbox(ClientID, checkboxState, redirectCallback);
            navigate(`/AssignModule?ClientID=${ClientID}`);
        } catch (error) {
            console.error('Error handling form submission:', error);
            // Handle error (e.g., display an error message)
        }
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                const RoleID = localStorage.getItem('RoleID');
                const FormAction = "/ModuleList";
                FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);

                // Get user's preferred language from i18next
                const lang = i18n.language || 'fr';

                let modulesData = await ModuleService.GetAllModulesWithClient(redirectCallback, lang, ClientID); // Pass the language parameter
                modulesData = modulesData.filter(x => x.PK_SearchModule_ID != 19 && x.PK_SearchModule_ID != 20);
                setModules(modulesData);

                const initialState = {};
                modulesData.forEach(module => {
                    initialState[module.PK_SearchModule_ID] = module.HostCompanyID !== null;
                });
                setCheckboxState(initialState);
            } catch (error) {
                console.error('Error fetching Users:', error);
            }
        }
        fetchData();
    }, [i18n.language]); // Listen to changes in language

    return (
        <div>
            <div className="main-content-header">
                <h1>Select Modules</h1>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">

                            <div className="table-responsive">
                                <table className="table datatable table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Select</th>
                                            <th>Module Name</th>
                                            <th>Module Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modulesList.map(module => (
                                            <tr key={module.PK_SearchModule_ID}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        name={module.PK_SearchModule_ID}
                                                        checked={checkboxState[module.PK_SearchModule_ID] || false}
                                                        onChange={event => {
                                                            if (module.vc_ModuleType === 'Core') {
                                                                event.preventDefault();
                                                            } else {
                                                                handleCheckboxChange(event);
                                                            }
                                                        }}
                                                    />
                                                </td>
                                                <td>{module.vc_ModuleName}</td>
                                                <td>{module.vc_ModuleType}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button type="button" onClick={handleSubmitForm} className="btn btn-primary">Assign</button>
                <Link className='btn btn-secondary' to={`/AssignModule?ClientID=${ClientID}`}>Back</Link>
            </div>
        </div>

    );
}

export default FormListPage;
